import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const API = "https://api.m3campus.com";

export default function Verificar() {
  const [params] = useSearchParams();

  useEffect(() => {
    const uid = params.get("uid");
    const token = params.get("token");

    if (!uid || !token) return;

    // ✅ Redirección REAL del navegador (no fetch)
    // El navegador seguirá el redirect del backend a /verificado
    window.location.href = `${API}/auth/verify/${uid}/${token}/`;
  }, [params]);

  return (
    <div style={{ padding: 32, textAlign: "center" }}>
      <h2>Verificando cuenta...</h2>
      <p>Espera un momento.</p>
    </div>
  );
}
